import { BaseFilter } from 'src/app/sharedFeatures/models/base-filter.model';
export class SectionLookupSearchModel extends BaseFilter {
  name!: string;
  description!: string;
}
